import { memo } from 'react';
import type { Entry } from 'contentful';
import { ComponentResolver } from '../../utils';

function MainMenuResolver({ mainMenu }: { mainMenu: Entry }) {
    return <ComponentResolver entry={mainMenu} />;
}

MainMenuResolver.displayName = 'MainMenuResolver';

export default memo(MainMenuResolver);
